package com.xtream.composeapp.viewmodel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.dto.ServerConfig
import com.xtream.data_kmp.remote.repo.DeviceInfo
import com.xtream.data_kmp.remote.repo.ServerConfigRepo
import com.xtream.data_kmp.remote.repo.XtreamRemoteRepo
import com.xtream.data_kmp.util.extension.getErrorMessage
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlin.time.Clock

class DataLoaderViewModel(
    private val serverConfigRepository: ServerConfigRepo,
    private val xtreamRemoteRepo: XtreamRemoteRepo,
    appSettingsRepo: PreferencesRepo

):  AppSettingsViewModel(appSettingsRepo) {
        var remoteDataState by mutableStateOf<ApiSealed<Any>>(ApiSealed.Initial)
        private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->throwable.printStackTrace()}

        /**
         * Fetches application configuration and data.
         *
         * This function initiates the data loading sequence. It first loads server configuration,
         * then proceeds to load user account and Xtream data. The UI state is updated to reflect
         * loading and potential errors.
         *
         * @param isTimeValid Indicates if the device time is valid, for error reporting.
         * @param context The Android [Context] for loading account data.
         * @param skipUserRefresh If true, skips refreshing user account data.
         * @param forceRefreshData Currently unused.
         */
        suspend fun fetchAppConfigAndData(isTimeValid: Boolean = true,
                                          deviceInfo: DeviceInfo,
                                          skipUserRefresh: Boolean = false,
                                          onDataUpdated: () -> Unit = {}
                                  ) {
                remoteDataState = ApiSealed.Loading
            val shouldRefreshData= needRefreshData()
           // Log.d("DataLoaderViewModel", "shouldRefreshData: $shouldRefreshData, skipUserRefresh: $skipUserRefresh")
                loadServerConfig(
                        onSuccess = {
                            when {
                                //if no user refresh needed but data update
                                skipUserRefresh && shouldRefreshData-> {
                                    // Refresh only data
                                    loadXtreamData(it)
                                }
                                //else if ony data update needed
                                shouldRefreshData -> {
                                    // Refresh user + refresh data
                                    loadXtreamAccountData(it, deviceInfo)
                                }
                                // if non of them needed
                                else -> {
                                    // Nothing to refresh
                                    remoteDataState = ApiSealed.Finished
                                }
                            }

                        },
                        onFail = {exception ->  setError(isTimeValid, exception) }
                       )
        }

        private fun loadXtreamAccountData(config: ServerConfig?, deviceInfo: DeviceInfo
        ){
                         xtreamRemoteRepo.loadXtreamAccount(
                                scope = viewModelScope,
                                deviceInfo=deviceInfo,
                                onSuccess = {
                                        loadXtreamData( config)
                                },
                                config=config,
                                onFail = {
                                        setError(true, it)
                                }

                        )


        }

        fun loadXtreamData(config: ServerConfig?) {

                xtreamRemoteRepo.loadStreams(
                        scope = viewModelScope,
                        onComplete = {
                            remoteDataState = when {
                                it == null -> {
                                  //  Log.d("DataLoaderViewModel", "Save last updated data millis")
                                    viewModelScope.launch(Dispatchers.Default) {
                                         setLastUpdatedDataMillis(Clock.System.now().toEpochMilliseconds())
                                    }
                                    ApiSealed.Success(Any())
                                }
                                else -> ApiSealed.Error(it.getErrorMessage() )
                            }
                        }
                )

        }


        private fun setStateSuccess(data:  ApiSealed<Any>?=null){
                remoteDataState = ApiSealed.Finished

        }
        private fun setError(
                isTimeValid: Boolean = true, exception: Throwable
        ) {
          //  Log.d("DataLoaderViewModel", "setError: $exception")
                remoteDataState = ApiSealed.Error(exception.getErrorMessage(isTimeValid), exception = exception)
        }


        fun loadServerConfig(
            onSuccess: ((ServerConfig?) -> Unit)? = null,
            onFail: ((Throwable) -> Unit)? = null
        ) {
                viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
                        val result = serverConfigRepository.fetchAndStoreServerConfig(SharedBuildKonfig.SERVER_CONFIG)

                        if (result.isSuccess) {
                                onSuccess?.invoke(result.getOrNull())
                        } else {
                                onFail?.invoke(result.exceptionOrNull() ?: Exception("Unknown error (SERVER_CONFIG)"))
                        }
                }
        }

}